import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { LabelNameMap } from '../step-label-map';

@Component({
  selector: 'app-efficiency-row-form',
  templateUrl: './efficiency-row-form.component.html',
  styleUrls: ['./efficiency-row-form.component.scss']
})
export class EfficiencyRowFormComponent implements OnInit {
  @Input() efficiencyForm!: AbstractControl | null;
  @Input() step!: string;
  @Input() labelMap!: LabelNameMap;
  @Input() ratings: (number)[] = [1, 2, 3, 4];

  get fg(): FormGroup | null {
    return this.efficiencyForm as FormGroup | null;
  }
  constructor() { }

  ngOnInit(): void {
  }

}
